<template>
    <v-card flat tile outlined :class="{ primary: active }" class="tab pa-1 fill-height">
        <v-row no-gutters justify="center" align="center" class="tab-row">
            <v-col cols="auto" class="px-1">
                <v-icon size="40" :class="{ 'primary--text': !active, 'white--text': active }">{{ icon }}</v-icon>
            </v-col>
            <v-col>
                <v-card-text :class="{ 'primary--text': !active, 'white--text': active }" class="subtitle-1 text-uppercase py-0">{{ label }}</v-card-text>
            </v-col>
            <v-col cols="auto">
                <v-card flat tile :class="{ primary: !active }">
                    <v-card-text :class="{ 'primary--text': active, 'white--text': !active }" class="display-1 py-2 px-3">{{ count }}</v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
    export default {
        props: {
            icon: {
                type: String,
                required: true
            },
            active: {
                type: Boolean,
                required: true
            },
            label: {
                type: String,
                required: true
            },
            count: {
                type: Number,
                required: true
            }
        }
    };
</script>

<style scoped>
    .tab {
        cursor: pointer;
    }
    .tab-row {
        min-height: 50px;
    }
    .subtitle-1 {
        line-height: 1em !important;
    }
    .display-1 {
        line-height: 1em !important;
    }
</style>
